"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoresInnerProductsInnerVariantsInnerImagesInnerToJSON = exports.StoresInnerProductsInnerVariantsInnerImagesInnerFromJSONTyped = exports.StoresInnerProductsInnerVariantsInnerImagesInnerFromJSON = exports.instanceOfStoresInnerProductsInnerVariantsInnerImagesInner = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the StoresInnerProductsInnerVariantsInnerImagesInner interface.
 */
function instanceOfStoresInnerProductsInnerVariantsInnerImagesInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoresInnerProductsInnerVariantsInnerImagesInner = instanceOfStoresInnerProductsInnerVariantsInnerImagesInner;
function StoresInnerProductsInnerVariantsInnerImagesInnerFromJSON(json) {
    return StoresInnerProductsInnerVariantsInnerImagesInnerFromJSONTyped(json, false);
}
exports.StoresInnerProductsInnerVariantsInnerImagesInnerFromJSON = StoresInnerProductsInnerVariantsInnerImagesInnerFromJSON;
function StoresInnerProductsInnerVariantsInnerImagesInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
        'altText': !(0, runtime_1.exists)(json, 'altText') ? undefined : json['altText'],
    };
}
exports.StoresInnerProductsInnerVariantsInnerImagesInnerFromJSONTyped = StoresInnerProductsInnerVariantsInnerImagesInnerFromJSONTyped;
function StoresInnerProductsInnerVariantsInnerImagesInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'url': value.url,
        'altText': value.altText,
    };
}
exports.StoresInnerProductsInnerVariantsInnerImagesInnerToJSON = StoresInnerProductsInnerVariantsInnerImagesInnerToJSON;
